/**
 * URL de base API.
 * - Dev sans REACT_APP_BACKEND_URL : '' → même origine + setupProxy.js → 127.0.0.1:3001
 * - Prod / preview : définir REACT_APP_BACKEND_URL au build
 */
export const BACKEND_URL =
  typeof process.env.REACT_APP_BACKEND_URL === 'string' && process.env.REACT_APP_BACKEND_URL.trim() !== ''
    ? process.env.REACT_APP_BACKEND_URL.replace(/\/$/, '')
    : ''
